@if(savingForm){
<create-account-placeholder-component [formName]="data.title"></create-account-placeholder-component>
}

<div
  class="app__solid--border rounded-xl bg-white border-[#e2e4e5] px-[26px] py-[18px] w-[636px]"
  [ngClass]="savingForm ? 'h-0 invisible absolute w-0' : visibility ? 'relative overflow-auto h-auto' : 'relative overflow-hidden h-auto'"
>
  @if(visibility){
  <div class="app__centered-item justify-between mb-[-5px]">
    <h4 class="app__form--attribute--title text-base font-semibold leading-[22px] text-[#1E1E20]">
      <span>Add new {{ data.title }}</span>
    </h4>
    <div class="app__close--icon mt-[-37px] mr-[-16px]">
      <button class="hover:cursor-pointer" matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons text-[#898F9E] text-[24px] leading-7 font-bold">clear</span>
      </button>
    </div>
  </div>
  <hr class="mx-[-26px]" />
  <p style="text-transform: capitalize" class="pr-3 pt-2 pb-2 sm:mb-0 text-sm font-bold">General Information</p>
  } @if(!visibility){
  <div class="loader-container" style="width: 90%; margin: auto; flex-direction: column">
    @for (item of loadingItems; track item) {
    <div>
      <div class="flex loader-body" id="{{ item.id }}" style="width: 100%">
        <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
          <div class="ph-col-12" style="padding: 0px !important">
            <div class="ph-row">
              <div class="ph-col-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  } @if (formData?.length) {
  <div [ngClass]="{ invisible: !visibility }" [style.height]="!visibility ? '0px !important' : 'auto !important'">
    <edit-template-basic-form [Form1]="formData" [documentForm]="documentForm"> </edit-template-basic-form>
  </div>
  } @if(visibility){
  <hr class="mx-[-26px] my-1" />
  <div class="w-full flex justify-end">
    <button
      style="margin-top: 12px !important"
      class="w-[102px] font-semibold sm:py-[7px] py-[7px] sm:text-[13px] text-[13px] m-0 max-[480px]:m-0 app__btn--primary"
      (click)="updateFormTemplateData()"
    >
      Save
    </button>
  </div>
  }
</div>
